import { render, staticRenderFns } from "./2fa_login.vue?vue&type=template&id=8bd26974&"
import script from "./2fa_login.vue?vue&type=script&lang=js&"
export * from "./2fa_login.vue?vue&type=script&lang=js&"
import style0 from "./2fa_login.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports